import React, { useEffect, useState, useCallback } from "react";
import call_icon from "../asset/images/partner-portal/phone-call.svg"
import mail_icon from "../asset/images/partner-portal/mail-icon.svg";
import whatsapp_icon from "../asset/images/partner-portal/whatsapp.svg";
import { Container, Row, Col, Modal, Button } from "react-bootstrap";
// import { ME_EventTriggered, customSelect, pauseAudio, playAudio, randomClickEvent, sendToCleverTap, adjustVal } from "../common/common.js";
import { Form } from "react-bootstrap";
import logoupdate from "../asset/images/partner-portal/bajaj-newIcon.svg";

function HeaderPartner(props) {
  const [selectedLanguage, setSelectedLanguage] = useState(true);
  const [playhome, setPlayHome] = useState(false);
  const [lang, setLang] = useLocalStorage("language", "English");
  function useLocalStorage(key, initialState) {
    const [value, setValue] = useState(
      localStorage.getItem(key) ?? initialState
    );
    const updatedSetValue = useCallback(
      (newValue) => {
        if (typeof newValue === "undefined") {
          localStorage.removeItem(key);
        } else {
          localStorage.setItem(key, newValue);
        }
        setValue(newValue ?? initialState);
      },
      [initialState, key]
    );
    return [value, updatedSetValue];
  }

  function languageChange() {
    setSelectedLanguage(!selectedLanguage);
  }


  return (
    <>
      <header className="header">
        <Container fluid>
          <div className="align-items-center">
            
              <div className="main-logo">
                {/* <a href="https://www.bajajfinservsecurities.in/ " > */}
                  <img src={logoupdate} alt="logo" width="145" height="41" />
                {/* </a> */}
              </div>
            
            {/* <Col xs={7}>

              <div className="header-right">
                <Form.Select
                  aria-label="Default select example"
                  className="custom-form-select mr-3"
                  id="LanguageSelect"
                  defaultValue={localStorage.getItem("language") ?? "English"}
                  onChange={languagesChanges}
                >
                  {AMCLanguage ? <option value="English">English</option>
                    : <><option value="English">English</option>
                      <option value="Hindi">Hindi</option>
                      <option value="Marathi">Marathi</option>
                      <option value="Gujarati">Gujarati</option></>}
                </Form.Select>

                <div className="header-list">
                  <ul>
                    <li>
                      <div>
                        <img src={call_icon} alt="" width="29" height="34" />

                      </div>
                    </li>
                    <li>
                      <div>
                        <img src={mail_icon} width="25" height="25" alt="" />
                        
                      </div>
                    </li>
                    <li>
                      <div>
                        <img src={whatsapp_icon} width="25" height="25" alt="" />
                        
                      </div>
                    </li>

                  </ul>
                </div>
              </div>
            </Col> */}
          </div>
        </Container>
      </header>
    </>
  );
}
export default HeaderPartner;
